<template>
  <div>
    <FormLabel
      v-bind="{
        label: 'Part Of Term Filters',
        disabled: !editable,
        description: 'Use custom filters to restrict the types of sections to which a part of term can be assigned.',
        status
      }"
      class="pt-2"
    />
    <DynamicFilters
      :value="value"
      :fields="config.filterFields || []"
      :view="config.view"
      :disabled="!editable"
      @input="update($event)"
    />
  </div>
</template>

<script>

import FormMixin from '@/components/Forms/FormMixin'
import FormLabel from '@/components/Forms/FormLabel'
import DynamicFilters from '@/components/DynamicFilters'

export default {
  name: 'FormDynamicFilters',
  mixins: [ FormMixin ],
  components: {
    FormLabel,
    DynamicFilters,
  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    formValue: {
      type: Object,
      default: () => ({}),
    },
    iteration: {
      type: Number,
      default: 0,
    },
    nestedMode: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => ({
        filterFields: [],
        view: 'sm',
      }),
    },
  },
}
</script>
